import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {Cmp} from './cmp';
import {ServiceBase} from '../../shared/services/service-base';
import {WorkrequestCmpViewmodel} from './workrequest-cmp-viewmodel';
import {UploadfilesViewmodel} from '../../shared/viewmodels/uploadfiles-viewmodel';
import {LoginService} from '../../shared/services/login.service';
import {FileUploadService} from '../../shared/services/file-upload.service';
import {ApplicationServiceBase} from '../../shared/services/application-service-base';
import {HttpClient,HttpHeaders} from '@angular/common/http';
import {FireCmpViewmodel} from './fire-cmp-viewmodel';
import {WorkrequestCmpDetails} from './workrequest-cmp-details';
import { UploadFile3Information } from '../../shared/data-objects/upload-file3-information';



@Injectable()
export class CmpService extends ApplicationServiceBase<Cmp> {
  agreedToTsAndCs2: boolean;
  agreedToTsAndCs1: boolean;
  workRequestViewModel: WorkrequestCmpViewmodel;
  uploadfilesViewmodel: UploadfilesViewmodel;
  fireCmpViewModel: FireCmpViewmodel;
  fileList:any
  static get submitUrl(): string {
    return ServiceBase.baseHref + '/api/submitCmpApplication';
  }

  constructor(protected http: HttpClient, protected loginService: LoginService, protected fileUploadService: FileUploadService) {
    super(http);
    const me = this;
    this.loginService.onLogout.subscribe(
      (next) => {
        me.initializeData();
      },
      (error) => {
        me.initializeData();
      }
    );
    this.initializeData();
  }

  initializeData(): void {
    super.initializeData();
    this.uploadfilesViewmodel = new UploadfilesViewmodel();
    this.workRequestViewModel = new WorkrequestCmpViewmodel();
    this.fireCmpViewModel = new FireCmpViewmodel();
    this.applicationData = new Cmp();
    this.applicationData.workrequestDetails = <WorkrequestCmpDetails>this.workRequestViewModel.workrequestDetails;
    this.fireCmpViewModel.workrequestDetails =  <WorkrequestCmpDetails>this.workRequestViewModel.workrequestDetails;
    this.agreedToTsAndCs1 = false;
    this.agreedToTsAndCs2 = false;
    this.agreedToTsAndCs = false;
    this.fileUploadService.clearFiles();

  }

  public submit(applicationDetails: Cmp, token: string): Observable<string> {
    this.workRequestViewModel.workrequestDetails.totalOrderAmount = this.workRequestViewModel.applicationFeeAmount;
    (<WorkrequestCmpDetails>this.workRequestViewModel.workrequestDetails)
      .appendWorkRequestDescription(this.workRequestViewModel.detailedDescription);
    applicationDetails.owner = applicationDetails.applicant;
    return super.submitImp(CmpService.submitUrl, applicationDetails, token);
  }
  
  addFile(fileList: any) {
    this.fileList = fileList    
 }
 private static get fileUploadUrl(): string {
  return ServiceBase.baseHref + '/api/fileupload/upload';
}
private static get updateFileInformationUrl(): string {
  return ServiceBase.baseHref + '/api/updatefile3upload';
}
private static getCookie(name: string): string {
  const ca: Array<string> = document.cookie.split(';');
  const caLen: number = ca.length;
  const cookieName = `${name}=`;
  let c: string;

  for (let i: any = 0; i < caLen; i += 1) {
    c = ca[i].replace(/^\s+/g, '');
    if (c.indexOf(cookieName) === 0) {
      return c.substring(cookieName.length, c.length);
    }
  }
  return '';
}

 
uploadFile(token: string): Observable<string[]> {

  const allObservables: Observable<string>[] = [];

  for (let i = 0; i < this.fileList.length; i++) {
    let file: any = this.fileList[i];
    file.file.attachmentType = this.fileList[i].attachmentType;
    allObservables.push(Observable.create((subscriber) => {
        const uploadError = (e): void => {
          subscriber.next(null);
          subscriber.complete();
        };
        const uploadComplete = (e): void => {
          if (e.target.status !== 200) {
            uploadError(e);
            return;
          }
          const locations = JSON.parse(e.target.responseText);
          subscriber.next(locations.err_desc);
          subscriber.complete();
        };

        const formData: FormData = new FormData();
        formData.append('file', file.file, ServiceBase.sanitizeString(file.file.name));

        const xhr: XMLHttpRequest = new XMLHttpRequest();
        xhr.open('POST', CmpService.fileUploadUrl, true);
        xhr.setRequestHeader('Authorization', 'Bearer ' + token);
        xhr.setRequestHeader('Accept', 'application/json');
        xhr.setRequestHeader('X-XSRF-TOKEN', CmpService.getCookie('XSRF-TOKEN'));
        xhr.addEventListener('load', uploadComplete, false);
        xhr.addEventListener('error', uploadError, false);
        // xhr.addEventListener('abort', uploadAbort, false);
        xhr.send(formData);
      }
    ));
  }

  return Observable.forkJoin(allObservables);
}

updateFileInformation(uploadFileInfo: UploadFile3Information, token: string): Observable<boolean> {
  const cleanuploadFileInfo = uploadFileInfo
  const header: HttpHeaders = new HttpHeaders()
    .append('Content-Type', 'application/json')
    .append('Authorization', 'Bearer ' + token);

  return this.http.post<boolean>(CmpService.updateFileInformationUrl, JSON.stringify(cleanuploadFileInfo), {headers: header});
}

}



// WEBPACK FOOTER //
// ./src/app/create-application/cmp-form/cmp.service.ts